import React
    from 'react';

import Person
  from '../../../../../assets/img/person-1.png'

import VisaWhite
  from '../../../../../assets/img/visa-white.svg'

import MasterCardWhite
  from '../../../../../assets/img/master-card-white.svg'

import { LoginForm, RegisterForm, ForgotPasswodForm }
  from '../../../../../components/auth'

import { fetchContract }
  from "../../../../../actions/contractsActions";

import { getCards, purchaseEntry }
  from '../../../../../helpers/payments'

import { addSubscription }
  from '../../../../../helpers/subscription'

import { getTranslate }
  from 'react-localize-redux';

import { connect }
  from 'react-redux';

import ReactLoading
  from 'react-loading';

import { getCurrency }
 from '../../../../../services/storeCurrency'

import CURRENCIES
 from '../../../../../constants/currencies'

import { toast } from 'react-toastify';

class CompanyDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      cards: [],
      currentCardSelected: null,
      payLoading: false
    };
  }

  componentDidMount() {
    getCards(this.catchResult.bind(this))
  }

  catchResult(data) {
    this.setState({cards: data.data, loading: false})
  }

  goNext() {
    window.$('#payment-details').modal('toggle');
    setTimeout(function(){
      window.$('#payment-success').modal('toggle');
    }, 250);
  }

  goToCreateNewCard() {
    window.$('#payment-details').modal('toggle');
    setTimeout(function(){
      window.$('#payment-addCard').modal('toggle');
    }, 250);
  }

  onChangeRadioValue(id) {
    this.setState({currentCardSelected: id})
  }

  displayCards() {
    let { cards, loading } = this.state

    if(loading){
      return(
        <div style={{ height: 100, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <ReactLoading type="spin" color="#bea58b" height={'10%'} width={'10%'} />
        </div>
      )
    }

    return (
      cards.map((card, index) => {
        let { card_number, card_owner, exp_month, exp_year, id, type } = card
        return (
          <div key={index} className="payment-radio" onChange={() => this.onChangeRadioValue(id)}>
            <input type="radio" id={`${id}-company`} value={id} className="radio" name="payment-item" />
            <label htmlFor={`${id}-company`}>
              <div className="payment-radio-icon">
                <img src={type = "Visa" ? VisaWhite : MasterCardWhite} />
              </div>
              <div className="payment-radio-content">
                <h3>{card_owner}</h3>
                <span className="card-number">**** **** **** {card_number}</span>
              </div>
            </label>
          </div>
        )
      })
    )
  }

  purchaseAction() {
    let { currentCardSelected } = this.state
    let { subscription, plan, interval } = this.props
    let _this = this

    // console.log(currentCardSelected, plan, interval)
    if(!currentCardSelected) {
      this.setState({error: "Not selected any card"})
    } else {
      this.setState({error: null, payLoading: true})
      if(subscription) {
        addSubscription({card_id: currentCardSelected, plan: plan.id, interval: interval}, this.successCatchResult.bind(this), this.handleErrors.bind(this))
      } else {
        purchaseEntry({cardId: currentCardSelected, entityType: "contract", entityId: this.props.item.id}, this.successCatchResult.bind(this), this.handleErrors.bind(this))
      }
    }
  }

  successCatchResult(data) {
    this.props.changeStatus("success")
  }

  handleErrors(data) {
    this.setState({error: data.errors, loading: false})
    if(data.code === 'payment_intent_authentication_failure') {
      this.setState({payLoading: false});
      toast.error('Payment failed due to no confirmation');
    }
  }

  displayPayButton() {
    let { translate } = this.props
    let { payLoading } = this.state
    if(payLoading){
      return(
        <div style={{ height: 100, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <ReactLoading type="spin" color="#bea58b" height={'10%'} width={'10%'} />
        </div>
      )
    }

    return (
      <button className="button button-primary" onClick={() => this.purchaseAction()}>
        <i className="icon-purchase"></i>{translate("payment.pay_now")}
      </button>
    )
  }

  displayHeaderInfo() {
    let { subscription, plan, translate, currencies, subCurrency } = this.props
    let currentCurrency = subCurrency
    if(plan && currencies['download_contract']) {
      return (
        <div className="payment-modal-info">
          <div className="payment-modal-info-wrap">
            <h2>{subscription ? plan.name : "Construction agreement"}</h2>
            <p>{subscription ? translate("payment.subscription") : translate("payment.contract")}</p>
          </div>
          <div className="payment-modal-info-price">
            {subscription ?
              <span>{currentCurrency.toUpperCase()} {plan.price}</span>
              :
              <span>{currencies['download_contract'][currentCurrency]}.- {currentCurrency.toUpperCase()}</span>
            }
          </div>
        </div>
      )
    }
  }

  showChooseSubscriptionModal() {
    setTimeout(function () {
      window.$('#subscription-company').modal('toggle');
    }, 400);
  }

  render() {
    let { translate } = this.props
    let { error } = this.state
    return (
      <div className="payment-modal-wrap modal-ge-wrap">
        <div className="modal-ge-top payment-modal-top">
          <h1>{translate("payment.title")}</h1>
        </div>
        <div className="modal-ge-body">
          <div className="payment-modal-title">
            <h3>{translate("payment.order_summery")}</h3>
          </div>
          {this.displayHeaderInfo()}
          <div className="payment-modal-title">
            <h3>{translate("payment.payment_method")}</h3>
          </div>
          {error && <p style={{marginBottom: 10, color: 'red'}}>{error}</p>}
          {this.displayCards()}
          <div className="payment-modal-add">
            <button className="button button-white" onClick={() => this.props.changeStatus("addCard")}><i className="icon-plus"></i>{translate("payment.add_new_payment_method")}</button>
          </div>
        </div>
        <div className="modal-ge-bottom">
          {this.displayPayButton()}
        </div>
        <div className="modal-ge-close" data-dismiss="modal" onClick={() => this.showChooseSubscriptionModal()}>
          <i className="icon-x"></i>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return ({
            translate: getTranslate(state.locale),
            current_user: state.currentUser,
            currencies: state.currencies
          })
}

export default connect(mapStateToProps, { fetchContract })(CompanyDetails);
